module.exports = __webpack_public_path__ + "static/media/designPatent_30-1001628.6fddf8c1.png";